import {ComplexFormControl, FieldType, FormBuilder, RequiredValidator} from "@ha/formhandler";

/** The values the login form holds. */
export type LoginFormData = {
    username: string,
    password: string
}

const required = new RequiredValidator();

/** Builds the login form: a username and a password field, both required. */
export function createLoginForm(): ComplexFormControl<LoginFormData, unknown> {
    return FormBuilder.buildForm('login', [
        {
            type: FieldType.Primitive,
            key: `username`,
            initialValue: ``,
            validations: [required]
        },
        {
            type: FieldType.Primitive,
            key: `password`,
            initialValue: ``,
            validations: [required]
        }
    ]);
}

/**
 * Whether the login form may be submitted: no field reports a validation error.
 *
 * Not `form.isValid`: on a form of fields, @ha/formhandler's `isValid` checks only validators
 * attached to the form itself, never those of its fields, so it stays true with both fields empty.
 */
export function isLoginFormSavable(form: ComplexFormControl<LoginFormData, unknown>): boolean {
    return form.getValidationErrors().length === 0;
}
